/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { destroyBiddingManaged } from 'store/modules/bidding_store/actions';
import { RequestState } from 'store/modules/bidding_store/types';
import { RequestState as BulletinRequestState } from 'store/modules/bulletins_store/types';
import { destroyBulletinManaged } from 'store/modules/bulletins_store/actions';
import { destroyManaged } from 'store/modules/management_store/actions';
import { ManagementState } from 'store/modules/management_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import createTrack from 'services/actions/tracker_actions';
import { destroyImminenceManaged } from 'store/modules/get_dados_imminence_store/actions';
import { ImminenceState } from 'store/modules/get_dados_imminence_store/types';

interface ManagementRemoveBiddingProps {
  modalRemoveBiddingOpened: boolean;
  setModalRemoveBiddingOpened: React.Dispatch<React.SetStateAction<boolean>>;
  biddingId: number;
  totalOpenedTaks: number;
  source?: string;
  bulletinFilterId?: number;
}

const ManagementRemoveBidding = (props: ManagementRemoveBiddingProps) => {
  const {
    modalRemoveBiddingOpened,
    setModalRemoveBiddingOpened,
    biddingId,
    totalOpenedTaks,
    source = 'management',
    bulletinFilterId = 0,
  } = props;
  const dispatch = useDispatch();

  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [saveClicked, setSaveClicked] = useState<boolean>(false);

  const { request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const management_request = useSelector<ApplicationState, RequestState>(
    (state) => state.session.biddings.request,
  );

  const bulletin_request = useSelector<ApplicationState, BulletinRequestState>(
    (state) => state.session.bulletins.request,
  );

  const { destroy_imminence_managed_request } = useSelector<ApplicationState, ImminenceState>(
    (state) => state.session.get_imminence,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const SHORT_DELAY = 2000;

  const removeManaged = () => {
    createTrack('Gestão de Licitações - Adicionou/retirou uma licitação do Gerenciamento');
    if (source === 'management')
      return dispatch(destroyManaged(biddingId, companyId(profile), profile.id));
    if (source === 'bulletin')
      return dispatch(
        destroyBulletinManaged(biddingId, bulletinFilterId, companyId(profile), profile.id),
      );
    if (source === 'imminence')
      return dispatch(destroyImminenceManaged(biddingId, companyId(profile)));
    return dispatch(destroyBiddingManaged(biddingId, companyId(profile), profile.id));
  };

  useEffect(() => {
    if (!saveClicked) return;
    if (
      request.managed.loading ||
      management_request?.destroy_managed_bidding?.loading ||
      bulletin_request?.destroy_bidding_managed_bulletin?.loading ||
      destroy_imminence_managed_request?.loading
    )
      return;

    setShowSuccess(true);
  }, [
    request.managed.loaded,
    management_request?.destroy_managed_bidding?.loaded,
    bulletin_request?.destroy_bidding_managed_bulletin?.loaded,
    destroy_imminence_managed_request?.loaded,
  ]);

  useEffect(() => {
    if (!showSuccess) return;

    setTimeout(() => {
      setShowSuccess(false);
      setModalRemoveBiddingOpened(false);
    }, SHORT_DELAY);
  }, [showSuccess]);

  useEffect(() => {
    if (!saveClicked) return;
    if (
      request.managed.loading ||
      management_request?.destroy_managed_bidding?.loading ||
      bulletin_request?.destroy_bidding_managed_bulletin?.loading ||
      destroy_imminence_managed_request?.loading
    )
      return;

    setShowError(true);
  }, [
    request.managed.error,
    management_request?.destroy_managed_bidding?.error,
    bulletin_request?.destroy_bidding_managed_bulletin?.error,
    destroy_imminence_managed_request?.error,
  ]);

  useEffect(() => {
    if (!showError) return;

    setTimeout(() => {
      setShowError(false);
    }, SHORT_DELAY);
  }, [showError]);

  return (
    <Modal show={modalRemoveBiddingOpened} size="sm">
      <div className="modal-content">
        <div className="modal-header">
          <h6 className="modal-title" id="modalLabel">
            Remover licitação
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setModalRemoveBiddingOpened(!modalRemoveBiddingOpened);
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          {showError && (
            <div className="my-2 alert alert-danger text-center">
              <button
                type="button"
                id="close-alert"
                className="close"
                onClick={() => setShowError(false)}
              >
                ×
              </button>
              Erro ao finalizar licitação.
            </div>
          )}
          {showSuccess && (
            <div className="my-2 alert alert-success text-center p-2 d-flex align-items-center">
              Licitação finalizada com sucesso!
              <button
                type="button"
                id="close-alert"
                className="ml-2 close"
                onClick={() => setShowSuccess(false)}
              >
                ×
              </button>
            </div>
          )}
          {totalOpenedTaks > 0 && (
            <div className="alert alert-warning" role="alert">
              Ao remover a licitação todas as tarefas em aberto serão excluídas. Deseja continuar?
            </div>
          )}
          <div className="form-row">
            <button
              type="button"
              className="btn btn-md btn-block btn-danger"
              onClick={() => {
                removeManaged();
                setSaveClicked(true);
              }}
            >
              Remover Licitação
            </button>
            <button
              type="button"
              id="close-alert"
              className="btn btn-md btn-block btn-primary"
              onClick={() => {
                setModalRemoveBiddingOpened(!modalRemoveBiddingOpened);
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ManagementRemoveBidding;
